export const getSucceededCooperationForm = (state) => state.entities.users.succeededCooperationForm;
